var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('div',{class:{ 'app-container': true, 'no-nav': _vm.showNav() }},[_c('Navigation'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('BottomFooter')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9903423e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":["src","data-rjs"],"image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/App/App.vue
// module id = null
// module chunks = 